import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { IVideoMetaData } from 'app/shared/model/video-meta-data.model';
import { getEntities as getVideoMetaData } from 'app/entities/video-meta-data/video-meta-data.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getEntity, updateEntity, createEntity, reset } from './video-view-history.reducer';
import { IVideoViewHistory } from 'app/shared/model/video-view-history.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IVideoViewHistoryUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const VideoViewHistoryUpdate = (props: IVideoViewHistoryUpdateProps) => {
  const [videoMetaDataId, setVideoMetaDataId] = useState('0');
  const [userId, setUserId] = useState('0');
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { videoViewHistoryEntity, videoMetaData, users, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/video-view-history');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }

    props.getVideoMetaData();
    props.getUsers();
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...videoViewHistoryEntity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="satshrutApp.videoViewHistory.home.createOrEditLabel">Create or edit a VideoViewHistory</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : videoViewHistoryEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="video-view-history-id">ID</Label>
                  <AvInput id="video-view-history-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="viewedDateLabel" for="video-view-history-viewedDate">
                  Viewed Date
                </Label>
                <AvField id="video-view-history-viewedDate" type="date" className="form-control" name="viewedDate" />
              </AvGroup>
              <AvGroup>
                <Label id="currentTickerLabel" for="video-view-history-currentTicker">
                  Current Ticker
                </Label>
                <AvField id="video-view-history-currentTicker" type="text" name="currentTicker" />
              </AvGroup>
              <AvGroup>
                <Label for="video-view-history-videoMetaData">Video Meta Data</Label>
                <AvInput id="video-view-history-videoMetaData" type="select" className="form-control" name="videoMetaData.id">
                  <option value="" key="0" />
                  {videoMetaData
                    ? videoMetaData.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.id}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <AvGroup>
                <Label for="video-view-history-user">User</Label>
                <AvInput id="video-view-history-user" type="select" className="form-control" name="user.id">
                  <option value="" key="0" />
                  {users
                    ? users.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.login}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/video-view-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  videoMetaData: storeState.videoMetaData.entities,
  users: storeState.userManagement.users,
  videoViewHistoryEntity: storeState.videoViewHistory.entity,
  loading: storeState.videoViewHistory.loading,
  updating: storeState.videoViewHistory.updating,
  updateSuccess: storeState.videoViewHistory.updateSuccess,
});

const mapDispatchToProps = {
  getVideoMetaData,
  getUsers,
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(VideoViewHistoryUpdate);
